module.exports = __webpack_public_path__ + "static/img/ava.fd42f19c.png";